export default "__VITE_ASSET__B5C8r6Br__"